import { render, staticRenderFns } from "./DictItemSelect.vue?vue&type=template&id=3c15531a&scoped=true&"
import script from "./DictItemSelect.vue?vue&type=script&lang=js&"
export * from "./DictItemSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c15531a",
  null
  
)

export default component.exports